import { call, put, takeLatest } from "redux-saga/effects";
import { authAPI } from "../../../services/auth/index"
import { sendLoginOTP, SEND_LOGIN_OTP } from "../../actions/auth.action"

function* handleSendLoginOTP(action) {
  try {
    const { data : resData} = yield call(authAPI.sendLoginOTP, action.payload);
    //extract the data here     
    yield put(sendLoginOTP.success({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  } catch (e) {
    const {data:resData} = e
    yield put(sendLoginOTP.failure({
      status:resData?.status,
      status_code:resData?.status_code,
      message:resData?.message,
      data:resData?.data
  }));
  }
}

function* sendLoginOTPSaga() {
  yield takeLatest(SEND_LOGIN_OTP.REQUEST, handleSendLoginOTP);
}

export default sendLoginOTPSaga;
